import { CommonService } from "../common.service";
var BigGuideComponent = (function () {
    function BigGuideComponent(commonService) {
        this.commonService = commonService;
        this.isHarmonyOS = false; //是否鸿蒙系统
    }
    BigGuideComponent.prototype.ngOnInit = function () {
        this.isHarmonyOS = this.commonService.isHarmonyOS();
    };
    BigGuideComponent.prototype.ngAfterViewInit = function () {
    };
    return BigGuideComponent;
}());
export { BigGuideComponent };



// WEBPACK FOOTER //
// ./src/app/big-guide/big-guide.component.ts.pre-build-optimizer.js